export default "__VITE_ASSET__B6f2PTzC__"